import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constant";
import LogoutConstant from "../../MainFrame/constants/Constants";
import restClient from "../../MainFrame/action/APIClient";

var UpdateNavigationListAction = function () {};

UpdateNavigationListAction.prototype = {
    updateNavigation: function (data) {
        var tab = data.navigationTab || data;
        var payload = Object.assign({}, data);
        if (tab.type !== 'RIGHT_NAV') {
            if (payload.navigationTab) {
                payload.navigationTab = Object.assign({}, payload.navigationTab);
                delete payload.navigationTab.padding;
                delete payload.navigationTab.background;
            } else {
                delete payload.padding;
                delete payload.background;
            }
        }
        restClient.updateNavigation(payload, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error,
                    });
                } else {
                    AppDispatcher.dispatch({
                        actionType: Constant.UPDATE_NAVIGATION_ITEMS,
                        data: error,
                    });
                }
            } else {
                response["status"] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.UPDATE_NAVIGATION_ITEMS,
                    data: response,
                });
            }
        });
    },
};

export default new UpdateNavigationListAction();
